const blockedEmails = ['gmail', 'hotmail', 'yahoo', 'icloud', 'outlook', 'uol'];

export const isValidProfessionalEmail = (professionalEmail: string) => {
  const domain = professionalEmail.split('@')[1];
  if (!domain) return false;

  const isBlocked = blockedEmails.some((blockedDomain) =>
    domain.toLowerCase().includes(blockedDomain.toLowerCase()),
  );

  return !isBlocked;
};

export const professionalEmailMessage = 'Email inválido';
